<template>
  <div id="app">
    <div class="page-content" :class="{ 'with-bottom-nav': showBottomNav }">
      <router-view></router-view>
      <BaseModal
        :visible="modalVisible"
        :title="modalTitle"
        :content="modalContent"
        :ok-text="modalOkText"
        :cancel-text="modalCancelText"
        :show-cancel="modalShowCancel"
        :show-footer="modalShowFooter"
        @ok="handleOk"
        @cancel="handleCancel"
        @close="closeModal"
      />
      <BaseLoading
        :visible="loadingVisible"
        :text="loadingText"
      />
      <BaseToast
        :visible="toastVisible"
        :message="toastMessage"
        :type="toastType"
      />
    </div>
    <nav class="bottom-nav" v-if="showBottomNav">
      <router-link to="/" exact class="nav-item">
        <img :src="currentPath === '/' ? homeActiveIcon : homeBaseIcon" alt="首页" class="nav-icon" />
        <span>首页</span>
      </router-link>
      <router-link to="/member" exact class="nav-item">
        <img :src="currentPath === '/member' ? memberActiveIcon : memberBaseIcon" alt="我的" class="nav-icon" />
        <span>我的</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
import homeBaseIcon from '@/assets/nav_icon/home_base.png'
import homeActiveIcon from '@/assets/nav_icon/home_active.png'
import memberBaseIcon from '@/assets/nav_icon/member_base.png'
import memberActiveIcon from '@/assets/nav_icon/member_active.png'
import BaseModal from '@/components/BaseModal.vue'
import BaseToast from '@/components/BaseToast.vue'
import BaseLoading from '@/components/BaseLoading.vue'
import { uiBus } from '@/utils/ui'

export default {
  name: 'App',
  components: {
    BaseModal,
    BaseToast,
    BaseLoading
  },
  computed: {
    currentPath() {
      return this.$route.path
    },
    showBottomNav() {
      return ['Home', 'Member'].includes(this.$route.name)
    }
  },
  data() {
    return {
      homeBaseIcon,
      homeActiveIcon,
      memberBaseIcon,
      memberActiveIcon,
      modalVisible: false,
      modalTitle: '提示',
      modalContent: '',
      modalOkText: '确定',
      modalCancelText: '取消',
      modalShowCancel: false,
      modalShowFooter: true,
      loadingVisible: false,
      loadingText: '加载中...',
      modalOkAction: null,
      modalCancelAction: null,
      toastVisible: false,
      toastMessage: '',
      toastType: 'info',
      toastTimer: null
    }
  },
  created() {
    uiBus.$on('ui-modal', this.openModal)
    uiBus.$on('ui-hide-modal', this.closeModal)
    uiBus.$on('ui-loading', this.openLoading)
    uiBus.$on('ui-hide-loading', this.closeLoading)
    uiBus.$on('ui-toast', this.openToast)
  },
  methods: {
    openModal(options = {}) {
      this.modalVisible = true
      this.modalTitle = options.title || ''
      this.modalContent = options.content || ''
      this.modalOkText = options.okText || '确定'
      this.modalCancelText = options.cancelText || '取消'
      this.modalShowCancel = !!options.showCancel
      this.modalShowFooter = options.showFooter !== false
      this.modalOkAction = typeof options.onOk === 'function' ? options.onOk : this.closeModal
      this.modalCancelAction = typeof options.onCancel === 'function' ? options.onCancel : this.closeModal
    },
    closeModal() {
      this.modalVisible = false
      this.modalOkAction = null
      this.modalCancelAction = null
    },
    openLoading({ text = '加载中...' } = {}) {
      this.loadingVisible = true
      this.loadingText = text
    },
    closeLoading() {
      this.loadingVisible = false
    },
    handleOk() {
      if (typeof this.modalOkAction === 'function') {
        this.modalOkAction()
      } else {
        this.closeModal()
      }
    },
    handleCancel() {
      if (typeof this.modalCancelAction === 'function') {
        this.modalCancelAction()
      } else {
        this.closeModal()
      }
    },
    openToast({ message = '', type = 'info', duration = 2000 } = {}) {
      if (!message) return
      clearTimeout(this.toastTimer)
      this.toastMessage = message
      this.toastType = type
      this.toastVisible = true
      this.toastTimer = setTimeout(() => {
        this.toastVisible = false
        this.toastTimer = null
      }, duration)
    }
  }
}
</script>

<style>
@import '@/assets/font/iconfont.css';

body {
  font-size: 14px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
}

.page-content {
  flex: 1;
}

.page-content.with-bottom-nav {
  padding-bottom: 60px; /* 给底部导航留出空间 */
}

.bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 56px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #ffffff;
  border-top: 1px solid #eaeaea;
  box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.05);
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #666;
  font-size: 12px;
  line-height: 1;
  padding: 6px 0;
}

.nav-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
}

.nav-item.active,
.nav-item.router-link-exact-active {
  color: #FF6600;
  font-weight: 600;
}
</style>
